import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { uploadAvatar, setGravatar, removeAvatar } from '../actions/AvatarActions';
import { getEmailHashFromCurrentUserProfile } from '../selectors/ProfileSelector';
import { getAvatarUrl } from '../selectors/AvatarSelector';
import { isUserImpersonated } from '../selectors/AuthSelector';
import { isRestrictedImpersonatee } from '../selectors/IsRestrictedImpersonateeSelector';
import Avatar from '../components/Avatar';
import { jsx as _jsx } from "react/jsx-runtime";
class AvatarContainer extends PureComponent {
  render() {
    const {
      avatarUrl,
      emailHash,
      disabled
    } = this.props;
    return /*#__PURE__*/_jsx(Avatar, {
      avatarUrl: avatarUrl,
      emailHash: emailHash,
      uploadAvatar: this.props.uploadAvatar,
      setGravatar: this.props.setGravatar,
      size: "lg",
      removeAvatar: this.props.removeAvatar,
      disabled: disabled
    });
  }
}
AvatarContainer.propTypes = {
  avatarUrl: PropTypes.string.isRequired,
  emailHash: PropTypes.string.isRequired,
  removeAvatar: PropTypes.func.isRequired,
  setGravatar: PropTypes.func.isRequired,
  uploadAvatar: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};
const mapStateToProps = state => {
  return {
    avatarUrl: getAvatarUrl(state),
    emailHash: getEmailHashFromCurrentUserProfile(state),
    disabled: isUserImpersonated(state) && !isRestrictedImpersonatee(state)
  };
};
export default connect(mapStateToProps, {
  uploadAvatar,
  setGravatar,
  removeAvatar
})(AvatarContainer);